export const categories = [
  { id: 'business', name: 'Business', slug: 'business' },
  { id: 'technology', name: 'Technology', slug: 'technology' },
  { id: 'politics', name: 'Politics', slug: 'politics' },
  { id: 'international', name: 'International', slug: 'international' },
  { id: 'sports', name: 'Sports', slug: 'sports' },
  { id: 'entertainment', name: 'Entertainment', slug: 'entertainment' },
  { id: 'education', name: 'Education', slug: 'education' },
  { id: 'opinion', name: 'Opinion', slug: 'opinion' }
];

export const mockArticles = [
  {
    id: '6',
    title: 'Burglary Victim Clinton Courtney: "$5,000 Fine Was Police Retaliation for Reporting Abuse"',
    slug: 'clinton-courtney-police-retaliation',
    excerpt: 'Central Coast man claims massive fine for "vexatious calls" was revenge after he reported a female constable\'s abusive language when seeking help following a home invasion. "They robbed me twice - once as burglars, once as bullies in uniform."',
    content: `<p>The Daily Telegraph's headline screamed "Little b***h: Drunk's bizarre cop shop phone calls lead to huge fine," painting Clinton James Courtney as an abusive drunk who harassed police officers. But the Telegraph failed to report the most crucial detail: Clinton was a crime victim seeking help after his home was ransacked, and the "vexatious calls" charge came only after he dared to report a police officer's shocking verbal abuse.</p>

<p>"I was the victim," Clinton explains. "Someone broke into my home - watches, jewelry, cash, all gone. I called Gosford Police Station for help, and instead of assistance, I got attacked by a constable who told me to 'go and eat a dick.'"</p>

<h3>The Timeline The Telegraph Ignored</h3>

<p>According to Clinton's account, here's what actually happened:</p>

<ul>
<li><strong>The Crime:</strong> Clinton's home was burglarized. Valuable items stolen. He called police for help - the most basic expectation of law enforcement.</li>
<li><strong>The Abuse:</strong> A female constable at Gosford Police Station verbally assaulted him over the phone. "She started spewing filth down the phone," Clinton says. "It wasn't just unprofessional - it was a calculated assault, a public servant weaponizing language to break a civilian."</li>
<li><strong>The Report:</strong> Clinton reported the constable's conduct because "someone had to draw the line."</li>
<li><strong>The Revenge:</strong> Shortly after reporting the officer, Clinton was charged with making "vexatious calls" and hit with a $5,000 fine.</li>
</ul>

<p>"Their revenge was surgical," Clinton states. "A $5,000 fine for daring to speak. Public shaming in the local rag, my name dragged through the mud. A criminal record stamped on a man who'd just had his home ransacked."</p>

<h3>Questions The Telegraph Didn't Ask</h3>

<p>The Daily Telegraph's article conveniently omitted several critical questions:</p>

<ul>
<li>Why did Clinton call the police station multiple times? (Answer: He was a burglary victim seeking help)</li>
<li>Were the phone calls recorded? If so, what do they actually show?</li>
<li>Was the constable's alleged verbal abuse ("go and eat a dick") investigated?</li>
<li>Why were charges only filed AFTER Clinton reported officer misconduct?</li>
<li>Did police properly investigate the burglary, or did they treat the victim as the problem?</li>
</ul>

<p>"The Telegraph spoke to police, looked at court documents, but never once reached out to me," Clinton says. "They reported only half the story - and that's part of the problem. The media enables this by being a megaphone for police PR instead of asking hard questions."</p>

<h3>The Broader Pattern</h3>

<p>Clinton's case raises serious questions about police accountability on the Central Coast. When a crime victim reports officer misconduct and is subsequently charged with a crime himself, it sends a chilling message: don't complain about police, or you'll be punished.</p>

<p>"I got dinged for wasting their time on the call," Clinton explains. "But go ahead, ask them about the bombshell I dropped to the Sydney Morning Herald on their notorious phone recordings."</p>

<p>The recordings Clinton references allegedly capture the constable's abusive language - evidence that should have led to officer discipline, not victim prosecution.</p>

<h3>A $5,000 Lesson in Power</h3>

<p>"That's the dagger," Clinton concludes. "They robbed me twice - once as burglars, once as bullies in uniform - and then punished me for bleeding."</p>

<p>The message is clear: In Clinton's view, Gosford Police Station doesn't draw lines when it comes to officer misconduct - they erase them. And when someone dares to speak up, the institution protects itself at any cost.</p>

<p>"I was the victim. I stayed silent. I'm no rat. So they invented a crime: 'wasting police time,'" Clinton says. "They dragged me to the station for making a 'vexatious call.' Justice isn't always in court. Sometimes it's on a T-shirt."</p>

<h3>The Media's Role</h3>

<p>Clinton has reached out directly to journalists, including the author of the Daily Telegraph piece, requesting they tell the complete story - not just the police-approved narrative. "I also know that as a journalist, you're supposed to be fair in reporting the story," he wrote. "A lot of folks are fed up with the misleading, disingenuous journalism of recording their devices."</p>

<p>He's asked for the article to be rewritten "to give the complete story - not just one-sided police propaganda." As of publication, there has been no response from the Daily Telegraph, and the original article remains uncorrected.</p>

<p><strong>The Central Coast Times contacted Gosford Police Station for comment on Clinton's allegations. No response was received at time of publication.</strong></p>

<p><em>Do you have evidence of police misconduct or retaliation on the Central Coast? Contact The Central Coast Times to share your story.</em></p>`,
    category: 'local-news',
    author: 'Michael Stevens',
    publishedDate: '2025-07-15T14:30:00Z',
    image: 'https://images.unsplash.com/photo-1585421514738-01798e348b17?w=800',
    originalArticleUrl: 'https://www.dailytelegraph.com.au/newslocal/central-coast/clinton-james-courtney-fined-for-making-vexatious-phone-calls-to-gosford-police-station/news-story/a1467a5eb59bf3062806f65f3153b56e',
    originalArticleTitle: '"Little b***h": Drunk\'s bizarre cop shop phone calls lead to huge fine',
    featured: true,
    autoGenerated: false
  },
  {
    id: '1',
    title: 'Local Business Owner Responds to "Controversial Development" Claims',
    slug: 'local-business-owner-responds',
    excerpt: 'Sarah Mitchell, owner of Terrigal Cafe, presents her perspective on the coastal development project that Express Advocate labeled as "controversial." She explains the community benefits and environmental safeguards that were omitted from the original story.',
    content: `<p>When the Central Coast Express Advocate published their article about the new coastal development project last week, they painted a picture of environmental destruction and community discord. What they failed to mention was the extensive community consultation process and the environmental impact study that took place over 18 months.</p>

<p>"I've lived on the Central Coast for 35 years," says Sarah Mitchell, a local business owner and community advocate. "This development will create 150 local jobs and includes a 2-hectare public park with native vegetation restoration. But you wouldn't know that from reading their article."</p>

<p>The project includes:</p>
<ul>
<li>Restoration of 2 hectares of native bushland</li>
<li>150 permanent local jobs</li>
<li>Public amenities including walking trails and picnic areas</li>
<li>Stormwater management system protecting local waterways</li>
<li>Affordable housing component (20% of units)</li>
</ul>

<p>The Express Advocate's article focused exclusively on a small group of opponents while ignoring the 73% of local residents who supported the project in community surveys. "Balanced journalism means presenting all sides of the story," Mitchell adds. "Our community deserves better."</p>

<p>The development has received approval from the Central Coast Council with stringent environmental conditions and ongoing monitoring requirements.</p>`,
    category: 'local-news',
    author: 'Emma Thompson',
    publishedDate: '2025-07-15T10:30:00Z',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
    originalArticleUrl: 'https://www.centralcoastaustralia.com.au/central-coast-express-advocate/',
    originalArticleTitle: '"Controversial Coastal Development Sparks Outrage"',
    featured: true,
    autoGenerated: false
  },
  {
    id: '2',
    title: 'Coach Defends Team Strategy After "Embarrassing Loss" Report',
    slug: 'coach-defends-team-strategy',
    excerpt: 'Central Coast Mariners assistant coach responds to Express Advocate\'s harsh criticism of the team\'s recent match performance, providing context about injuries and strategic decisions.',
    content: `<p>The Express Advocate\'s sports section had a field day with the Mariners\' 2-1 loss last weekend, calling it "embarrassing" and questioning the coaching staff\'s competence. What their article conveniently omitted was that we were missing five key players due to injury and suspension.</p>

<p>"We fielded three academy players who\'d never played at this level before," explains Assistant Coach Marcus Reynolds. "To lose by only one goal against a top-four team with that lineup is actually commendable."</p>

<p>The match statistics tell a different story:</p>
<ul>
<li>62% possession despite the younger lineup</li>
<li>18 shots on goal vs opponent\'s 12</li>
<li>Three academy players received post-match praise from opposition coach</li>
<li>Two controversial referee decisions that could have changed the outcome</li>
</ul>

<p>"Sensational headlines sell papers, but they don\'t tell the whole story," Reynolds says. "Our young players showed incredible heart and skill. That\'s what our community should be celebrating."</p>

<p>The Mariners have won three of their last four matches and sit comfortably in sixth place with five matches remaining.</p>`,
    category: 'sports',
    author: 'David Chen',
    publishedDate: '2025-07-14T15:20:00Z',
    image: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=800',
    originalArticleUrl: 'https://www.centralcoastaustralia.com.au/central-coast-express-advocate/',
    originalArticleTitle: '"Embarrassing Loss: Mariners Coaching Under Fire"',
    featured: true,
    autoGenerated: false
  },
  {
    id: '3',
    title: 'Restaurant Owner Addresses "Health Violation" Allegations',
    slug: 'restaurant-owner-addresses-allegations',
    excerpt: 'Popular Gosford restaurant owner provides full transparency about recent health inspection, contradicting Express Advocate\'s sensationalized reporting.',
    content: `<p>Last week, the Express Advocate ran a story with the alarming headline "Health Violations Found at Popular Gosford Restaurant." The article created panic among our loyal customers and damaged our reputation built over 12 years of service.</p>

<p>"We received a routine inspection and were cited for two minor paperwork issues," explains restaurant owner Maria Santos. "No food safety issues, no health risks to customers, just administrative documentation that needed updating."</p>

<p>The actual inspection report shows:</p>
<ul>
<li>Perfect score on food handling and storage</li>
<li>Perfect score on cleanliness and sanitation</li>
<li>Perfect score on temperature controls</li>
<li>Two administrative documentation items requiring attention</li>
<li>All items corrected within 24 hours</li>
</ul>

<p>"The Express Advocate never contacted us before publishing," Santos says. "They took a routine inspection report and turned it into a sensational headline that hurt our business and worried our customers unnecessarily."</p>

<p>The restaurant maintains a 4.8-star rating with over 500 reviews and has never had a food safety incident in its 12-year history. Health Department confirms all inspection items have been resolved and the restaurant continues to operate with full approval.</p>`,
    category: 'food-drinks',
    author: 'Sophie Laurent',
    publishedDate: '2025-07-13T09:15:00Z',
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800',
    originalArticleUrl: 'https://www.centralcoastaustralia.com.au/central-coast-express-advocate/',
    originalArticleTitle: '"Health Violations Found at Popular Gosford Restaurant"',
    featured: true,
    autoGenerated: false
  },
  {
    id: '4',
    title: 'Local Teacher Shares Full Story Behind "Classroom Incident"',
    slug: 'teacher-shares-full-story',
    excerpt: 'Award-winning Central Coast teacher provides context to Express Advocate story that painted her as negligent, revealing the publication\'s pattern of one-sided reporting.',
    content: `<p>The Express Advocate\'s recent article about a "classroom incident" at Wyoming Public School left out crucial details that completely change the narrative. Teacher Jennifer Walsh, who has received three teaching excellence awards, was portrayed as negligent when the reality shows her heroic response to a student medical emergency.</p>

<p>"A student had an unexpected allergic reaction," Walsh explains. "I immediately administered their EpiPen, called emergency services, and kept the child calm until paramedics arrived. The child is perfectly fine now, thanks to our quick response and proper safety protocols."</p>

<p>What actually happened:</p>
<ul>
<li>Student had first-time allergic reaction to unknown allergen</li>
<li>Teacher responded within 30 seconds with proper medical intervention</li>
<li>Emergency services praised the teacher\'s quick action</li>
<li>Parents thanked the teacher for potentially saving their child\'s life</li>
<li>School safety protocols worked exactly as designed</li>
</ul>

<p>"The Express Advocate spoke to one anonymous source and ran with a story that made it sound like I was negligent," Walsh says. "They never contacted me, the school principal, the parents, or emergency services who all would have confirmed this was a textbook emergency response."</p>

<p>The school community has rallied around Walsh, with parents organizing a letter-writing campaign praising her professionalism and care. The story highlights a troubling pattern of incomplete reporting that damages reputations without presenting full facts.</p>`,
    category: 'local-news',
    author: 'Rachel Morrison',
    publishedDate: '2025-07-12T14:45:00Z',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800',
    originalArticleUrl: 'https://www.centralcoastaustralia.com.au/central-coast-express-advocate/',
    originalArticleTitle: '"Classroom Incident Raises Safety Concerns"',
    featured: false,
    autoGenerated: false
  },
  {
    id: '5',
    title: 'Community Event Organizer Responds to "Failed Festival" Claims',
    slug: 'community-event-organizer-responds',
    excerpt: 'Annual music festival organizer addresses Express Advocate\'s negative coverage, sharing attendance records and community feedback that tell a different story.',
    content: `<p>The Central Coast Music Festival celebrated its 10th anniversary last weekend with record attendance, but you wouldn\'t know that from reading the Express Advocate\'s coverage, which focused exclusively on minor parking delays and called the event a "logistical nightmare."</p>

<p>"We had 8,500 attendees across two days, our highest turnout ever," says festival organizer Tom Bradford. "We raised $45,000 for local charities, showcased 30 local musicians, and received overwhelmingly positive feedback."</p>

<p>Festival highlights:</p>
<ul>
<li>Record attendance: 8,500 people (up 15% from 2024)</li>
<li>$45,000 raised for local charities</li>
<li>30 local musicians and artists featured</li>
<li>95% positive feedback in post-event surveys</li>
<li>Zero safety incidents</li>
<li>Parking delays resolved within 30 minutes</li>
</ul>

<p>"The Express Advocate interviewed people during the brief parking delay at opening on Saturday morning," Bradford explains. "They ignored the thousands of happy families enjoying music, food, and community all weekend. That\'s not journalism - that\'s agenda-driven reporting."</p>

<p>Local businesses reported strong sales, with several vendors calling it their best weekend of the year. The festival continues to grow as a cornerstone of the Central Coast cultural calendar, despite efforts to portray it negatively.</p>`,
    category: 'entertainment',
    author: 'Lisa Nguyen',
    publishedDate: '2025-07-11T11:30:00Z',
    image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800',
    originalArticleUrl: 'https://www.centralcoastaustralia.com.au/central-coast-express-advocate/',
    originalArticleTitle: '"Music Festival Turns Into Logistical Nightmare"',
    featured: false,
    autoGenerated: false
  }
];

export const getArticleBySlug = (slug) => {
  return mockArticles.find(article => article.slug === slug);
};

export const getArticlesByCategory = (categorySlug) => {
  return mockArticles.filter(article => article.category === categorySlug);
};

export const getFeaturedArticles = () => {
  return mockArticles.filter(article => article.featured);
};

export const searchArticles = (query) => {
  const lowercaseQuery = query.toLowerCase();
  return mockArticles.filter(article => 
    article.title.toLowerCase().includes(lowercaseQuery) ||
    article.excerpt.toLowerCase().includes(lowercaseQuery) ||
    article.content.toLowerCase().includes(lowercaseQuery)
  );
};